// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IServiceLiteWithCategoryTypeDto
 */
export interface IServiceLiteWithCategoryTypeDto {
    /**
     * 
     * @type {number}
     * @memberof IServiceLiteWithCategoryTypeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IServiceLiteWithCategoryTypeDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IServiceLiteWithCategoryTypeDto
     */
    category_type?: IServiceLiteWithCategoryTypeDtoCategoryTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IServiceLiteWithCategoryTypeDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the IServiceLiteWithCategoryTypeDto interface.
 */
export function instanceOfIServiceLiteWithCategoryTypeDto(value: object): value is IServiceLiteWithCategoryTypeDto {
    return true;
}

export function IServiceLiteWithCategoryTypeDtoFromJSON(json: any): IServiceLiteWithCategoryTypeDto {
    return IServiceLiteWithCategoryTypeDtoFromJSONTyped(json, false);
}

export function IServiceLiteWithCategoryTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IServiceLiteWithCategoryTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
    };
}

export function IServiceLiteWithCategoryTypeDtoToJSON(json: any): IServiceLiteWithCategoryTypeDto {
    return IServiceLiteWithCategoryTypeDtoToJSONTyped(json, false);
}

export function IServiceLiteWithCategoryTypeDtoToJSONTyped(value?: IServiceLiteWithCategoryTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'category_type': value['category_type'],
    };
}

